// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"b81bcc99","188":"fe1e3611","287":"8e44294d","411":"fc2b99b3","427":"170316b1","524":"969eeb20","844":"f84b7a3a"}[chunkId] + ".chunk.css";
};